import { View} from "@react-pdf/renderer";
import { PDFTable } from "ui/components/PDF";
import useItensOrcamentoPdfColumns from "./hooks/useItensOrcamentoPdfColumns";
import { OrcamentoItem } from 'features/orcamento/typings';

interface PDFItensOrcamentoTableProps {
  item: OrcamentoItem[];
}

function ItemTable({ item }: PDFItensOrcamentoTableProps) {
  const columns = useItensOrcamentoPdfColumns();

  return (
    <View>
      <PDFTable
        data={item}
        columns={columns}
        tableHeaderVariant="rowLike"
      />
    </View>
  );
}

export default ItemTable;
